// frontend/src/components/entry/LeaveForShopifyDoor.jsx
//
// A protected route, an anonymous visitor, and a door URL for the shop this
// browser last signed in from (AuthContext.shopifySignInUrl): send the
// document through the door with this route as `next`, and hold the loading
// screen while it leaves — the login page is never drawn. Rendered by
// App.jsx ProtectedLayout only, so public routes are never redirected.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { doorWithNext } from '../../utils/shopifyDoor';

export default function LeaveForShopifyDoor({ doorUrl }) {
  const { t } = useTranslation();
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.location.replace(doorWithNext(doorUrl, `${pathname}${search}`));
  }, [doorUrl, pathname, search]);

  return (
    <div className="app-loading">
      <div className="app-loading-content">
        <div>{t('session.handoff')}</div>
      </div>
    </div>
  );
}
